<template>
  <div class="template-card">
    <h2 class="mb-[12px] mt-0 font-[600]">{{ data.title }}</h2>
    <p class="mb-[32px] mt-0 font-[500]">{{ data.desc }}</p>
    <CarouselList class="template-card-carousel" :total="calList.length">
      <SwiperSlide v-for="item in calList" :key="item.id">
        <CardItem
          :data="item"
          :auto-scale="true"
          @click="onHandleClick(item)"
          @change="onChange($event, item)"
        ></CardItem>
      </SwiperSlide>
    </CarouselList>
  </div>
</template>

<script lang="ts" setup>
import { SwiperSlide } from 'swiper/vue'
import CarouselList from '../carousel-list.vue'
import CardItem from '~/features/template/components/cardItem.vue'
import type { ScenariosTemplateConfig, Template } from '~/api/interface'
import { useStarPatchList } from '~/hooks/useStarPatch'
import { getTemplateSearch } from '~/api'
import { useTemplateDetail } from '~/hooks/useModal/modals/template'

interface CardProps {
  data: ScenariosTemplateConfig
  filteredTemplates: number[]
}

const props = defineProps<CardProps>()

const feedback = ref<Template[]>([])

const onChange = ([key, value]: [string, any], data: Template) => {
  const item = calList.value.find((item) => item.id === data.id)
  if (item) {
    item[key] = value
  }
}

const getTemplates = async () => {
  const tag_ids = props.data.tag_ids.join('_')
  const res = await getTemplateSearch({
    page: 1,
    page_size: 50,
    tag_ids,
    platform: 0,
    online_status: 0,
    exclude_template_ids: props.filteredTemplates.join(','),
    query_star: import.meta.client,
  })
  res.data?.results?.forEach((item) => {
    item.query_star = import.meta.client // 标记这些数据是否查询过star
  })
  return res.data?.results || []
}

onMounted(async () => {
  feedback.value = await getTemplates()
})

const list = computed(() => feedback.value || [])

const { calList } = useStarPatchList(list, 3)

const resourceLocation = injectResourceLocation()

const onHandleClick = (data: Template) => {
  useTemplateDetail(calList.value, data, {
    source: resourceLocation?.source,
  })
}
</script>

<style lang="scss" scoped>
h2 {
  font-size: 24px;
  font-weight: 600;
  line-height: 36px;
  text-align: center;
}

p {
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  width: 100%;
  text-align: center;
  color: var(--text-1-60);
}

.template-card-carousel {
  width: 1200px;
  margin: 0 auto;
  :deep(.swiper-wrapper) {
    height: 221px;
  }
  :deep(.unveil) {
    height: 179px;
    flex: auto !important;
  }
  :deep(.info) {
    height: 60px;
    flex: auto !important;
  }
}
</style>
